import { Theme } from '@mui/material/styles';
import { BORDER_RADIUS } from '@/theme/tokens';

export const getAutoCompleteAddressInputStyles = (theme: Theme) => ({
  container: {
    position: 'relative',
  },
  textField: {
    // Fill the rounded input itself, not the TextField root — a root-level
    // background paints a squared rectangle behind the rounded field.
    '& .MuiOutlinedInput-root': {
      borderRadius: BORDER_RADIUS,
      backgroundColor: theme.tokens.colors.background,
    },
  },
  suggestionsPaper: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 9999,
    maxHeight: 240,
    overflow: 'auto',
    border: `1px solid ${theme.tokens.colors.borderLight}`,
    borderRadius: BORDER_RADIUS,
    backgroundColor: theme.tokens.colors.background,
    boxShadow: `0 4px 6px ${theme.tokens.colors.shadowLight}`,
    marginTop: '4px',
  },
  suggestionItem: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.tokens.colors.surfaceNeutral,
    },
    borderBottom: `1px solid ${theme.tokens.colors.surfaceNeutral}`,
  },
  primaryText: {
    fontSize: '14px',
    fontWeight: 500,
  },
  secondaryText: {
    fontSize: '12px',
    color: theme.tokens.colors.textTertiary,
  },
});
